import { render, staticRenderFns } from "./produce.vue?vue&type=template&id=a379c680&scoped=true"
import script from "./produce.vue?vue&type=script&lang=js"
export * from "./produce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.18_babel-core@6.26.3_css-loader@6.11.0_webpack@5.100_4xpmdqc3iaixeru4y6alscik5i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a379c680",
  null
  
)

export default component.exports